import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { PropsWithoutChildren } from '../../utils/utilityTypes';
import { classes } from '../../utils/utils';
import styles from './ExpandableInlineCreationForm.module.css';
export type ExpandableInlineCreationFormProps = PropsWithoutChildren<ComponentProps<'div'>> & {
  opened: boolean;
  label: string;
  openedContent: React.ReactNode;
  notOpenedContent: React.ReactNode;
  buttons: React.ReactNode;
};
export type ExpandableInlineCreationFormContent = {
  renderOpenedContent: () => React.ReactNode | Array<React.ReactNode>;
  renderNotOpenedContent: () => React.ReactNode | Array<React.ReactNode>;
  renderButtons: () => React.ReactNode | Array<React.ReactNode>;
};
export const ExpandableInlineCreationForm: FunctionComponent<ExpandableInlineCreationFormProps> = React.memo(props => {
  const $ = _c(17);
  let buttons;
  let label;
  let openedContent;
  let t0;
  let t1;
  let t2;
  if ($[0] !== props) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const {
        opened,
        label: t3,
        className,
        openedContent: t4,
        notOpenedContent,
        buttons: t5,
        ...remainingProps
      } = prepareProps({
        props,
        ignoreChildren: true
      });
      label = t3;
      openedContent = t4;
      buttons = t5;
      if (!opened) {
        t2 = <div {...remainingProps}>{notOpenedContent}</div>;
        break bb0;
      }
      t0 = remainingProps;
      t1 = classes(className, styles.container);
    }
    $[0] = props;
    $[1] = buttons;
    $[2] = label;
    $[3] = openedContent;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    buttons = $[1];
    label = $[2];
    openedContent = $[3];
    t0 = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  let t3;
  if ($[7] !== label) {
    t3 = <div className={styles.label}>{label}</div>;
    $[7] = label;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== buttons) {
    t4 = buttons ? <div className={styles.buttonWrapper}>{buttons}</div> : undefined;
    $[9] = buttons;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== openedContent || $[12] !== t0 || $[13] !== t1 || $[14] !== t3 || $[15] !== t4) {
    t5 = <div {...t0} className={t1}>{t3}{openedContent}{t4}</div>;
    $[11] = openedContent;
    $[12] = t0;
    $[13] = t1;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
});